exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scroll-view[data-v-7c8da7d7] {\n  padding: 0;\n  list-style: none;\n  position: relative;\n  margin: 0;\n  background-color: #fff;\n}\n.scroll-view[data-v-7c8da7d7]  .infinite-loading-container {\n    background-color: #e9f4fb;\n}\n", ""]);

// exports
